module.exports = __webpack_public_path__ + "img/delete-outline-rounded.2e9f1fbf.svg";